export class OtherOccupant {
    constructor (
        public RentalApplicationKey: number = 0,
        public RentalOtherOccupantsKey: number = 0,
        public Name: string = '',
        public BirthYear: number = null,
        public PropertyKey: number = null,
        public RentalApplicant_RentalApplicantKey:number=0,
        public IsDisabled:boolean=false,
    ) { }
}
